<div class="sign-ups-part">

	<readonly-access [readonly]="service.isReadonly()"></readonly-access>

	<grid-content [setup]="setup" [namedSize]="'CustomHeight'" [customHeight]="customHeight()" [rows]="specialists()"></grid-content>
</div>